import React from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Differentiators from './components/Differentiators';
import Team from './components/Team';
import BuildWithUs from './components/BuildWithUs';
import './App.css';

export default function App() {
  return (
    <div className="app">
      {/* Ambient background blobs */}
      <div className="ambient-bg">
        <div className="blob blob-1" />
        <div className="blob blob-2" />
        <div className="blob blob-3" />
      </div>

      <Navbar />
      <Hero />
      <Differentiators />
      <Team />
      <BuildWithUs />
    </div>
  );
}
